import type { NumberFormatValues, OnValueChange } from 'react-number-format';

/**
 * Wraps a `react-number-format` `onValueChange` handler so it only sees what the user typed.
 *
 * v5 also invokes `onValueChange` when the `value` prop changes, echoing the formatted result back
 * with `sourceInfo.source === 'prop'`. Our handlers write that value into Formik, so left unfiltered
 * the echo rewrites a programmatic change: a loaded 1234.567 becomes 1234.57, a reset to `''`
 * becomes `null`, and the caller's `onChange` fires for an edit the user never made. Filtering on the
 * source restores the v4 contract, where the callback meant user input.
 */
const onUserValueChange =
  (handler: (values: NumberFormatValues) => void): OnValueChange =>
  (values, sourceInfo) => {
    if (sourceInfo.source === 'event') {
      handler(values);
    }
  };

export default onUserValueChange;
